'use client';

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import i18nConfig from '@i18nConfig';
import { NameSpace, Locales } from '@/types/i18n';

// Create a singleton instance for client-side usage
const i18nInstance = i18next.createInstance();

// Initialize the instance
i18nInstance
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      ((language: Locales, namespace: NameSpace) =>
        import(`@/locales/${language.replace('-', '_')}/${namespace}.json`)
      ) as unknown as typeof resourcesToBackend
    )
  )
  .init({
    lng: i18nConfig.defaultLocale,
    fallbackLng: i18nConfig.defaultLocale,
    supportedLngs: i18nConfig.locales,
    defaultNS: 'translation',
    fallbackNS: 'translation',
    ns: ['translation'],
    debug: false,
    react: {
      useSuspense: false // This helps avoid issues with SSR
    }
  }, (err) => {
    if (err) console.error('i18next initialization error:', err);
  });

export default i18nInstance;
